export const VISIBLE_BANNER_AMOUNT = 10
export const VISIBLE_FAVOURITE_CARDS_AMOUNT = 10
export const VISIBLE_USER_REVIEW_AMOUNT = 9
export const VISIBLE_FAVOURITE_BRANDS_AMOUNT = 4
export const VISIBLE_PRODUCTLINE_CARDS_AMOUNT = 2
export const VISIBLE_PRODUCT_CARDS_AMOUNT = 4
export const DAYS_PER_MONTH = 30
export const BANNER_INDEX = 2
export const VISIBLE_PRODUCT_REVIEW_CARDS = 4
export const VISIBLE_BlOGPOST_REVIEW_CARDS = 3
export const DAILY_ENERGY_REQUIREMENTS_COEFICIENT_DEFAULT = 0.75
export const DEFINED_DAILY_DOSE_COEFICIENT = 1000
export const PREGNANCY_COEFICIENT = 132 // kcal/kg
export const PREGNANCY_ADVANCED_COEFICIENT = 26 // kcal/kg
export const BREASTFEEDING_COEFICIENT = 145 // kcal/kg
export const BREASTFEEDING_LOW_LITTER_EXTRA_COEFICIENT = 24
export const BREASTFEEDING_HIGH_LITTER_EXTRA_COEFICIENT = 96
export const BREASTFEEDING_HIGH_LITTER_EXTRA_PUPPY_COEFICIENT = 12
export const PUPPY_COEFICIENT = 250 // kcal/kg
export const PUPPY_ADVANCED_COEFICIENT_ONE = 254.1 // kcal/kg
export const PUPPY_ADVANCED_COEFICIENT_TWO = 135 // kcal/kg
export const BODY_CONDITION_SYSTEM_COEFICIENT = 5
export const LARGE_SELECT_HEIGHT = 58
export const END_LIST_CARD_VISIBLE_AMOUNT = 10
export const BAR_VISIBLE_ITEMS = 5
export const MAX_DAYS_PACK_OPENED = 60
export const INTRO_ROWS_HEIGHT = 190
export const INTRO_ROWS_HEIGHT_MOBILE = 94
